/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

import qualityRequirement from 'fera-prop-types/storylet/qualityRequirement';

export default PropTypes.shape({
  id: PropTypes.number.isRequired,
  qualityRequirements: PropTypes.arrayOf(qualityRequirement),
  teaser: PropTypes.string, // We don't always have teaser data
});